import { render, staticRenderFns } from "./RegistrationLayoutTitles.vue?vue&type=template&id=029b6862"
import script from "./RegistrationLayoutTitles.vue?vue&type=script&lang=js"
export * from "./RegistrationLayoutTitles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports